import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: process.env.OTC_STANDALONE ? 'otc' : 'dashboard',
    hidden: process.env.OTC_STANDALONE,
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {title: 'dashboard', icon: 'dashboard3', noCache: true}
      }
    ]
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/axie',
    component: Layout,
    redirect: 'noredirect',
    name: 'axie',
    meta: {title: 'AXIE', icon: 'axie'},
    children: [
      {
        path: 'ronin_pool',
        component: () => import('@/views/axie/ronin_pool'),
        name: 'ronin_pool',
        meta: {title: '钱包号池', icon: 'si-glyph-christmass-egg', noCache: true, roles: ['AXIE_AUTO']}
      },
      {
        path: 'mother',
        component: () => import('@/views/axie/mother'),
        name: 'mother',
        meta: {title: '游戏母号', icon: 'si-glyph-baby-troller', noCache: true, roles: ['AXIE_AUTO']}
      },
      {
        path: 'ronin',
        component: () => import('@/views/axie/ronin'),
        name: 'ronin',
        meta: {title: '钱包注册', icon: 'axie-ronin', noCache: true, roles: ['AXIE_RONIN']}
      },
      {
        path: 'ronin_detail',
        component: () => import('@/views/axie/ronin_detail'),
        name: 'ronin_detail',
        meta: {title: '钱包注册列表', noCache: true, roles: ['AXIE_RONIN']},
        hidden: true
      },
      {
        path: 'pet',
        component: () => import('@/views/axie/pet'),
        name: 'pet',
        meta: {title: '宠物传送', icon: 'axie-pet', noCache: true, roles: ['AXIE_PET']}
      },
      {
        path: 'pet_detail',
        component: () => import('@/views/axie/pet_detail'),
        name: 'pet_detail',
        meta: {title: '宠物传送列表', noCache: true, roles: ['AXIE_PET']},
        hidden: true
      },
      {
        path: 'qrcode',
        component: () => import('@/views/axie/qrcode'),
        name: 'qrcode',
        meta: {title: '提二维码', icon: 'qrcode', noCache: true, roles: ['AXIE_QRCODE']}
      },
      {
        path: 'qrcode_detail',
        component: () => import('@/views/axie/qrcode_detail'),
        name: 'qrcode_detail',
        meta: {title: '提二维码列表', noCache: true, roles: ['AXIE_QRCODE']},
        hidden: true
      },
      {
        path: 'claim',
        component: () => import('@/views/axie/claim'),
        name: 'claim',
        meta: {title: '提取药水', icon: 'axie-claim', noCache: true, roles: ['AXIE_CLAIM']}
      },
      {
        path: 'claim_detail',
        component: () => import('@/views/axie/claim_detail'),
        name: 'claim_detail',
        meta: {title: '提取药水列表', noCache: true, roles: ['AXIE_CLAIM']},
        hidden: true
      },
      {
        path: 'account',
        component: () => import('@/views/axie/account'),
        name: 'account',
        meta: {title: '游戏帐号', icon: 'si-glyph-game-1', noCache: true, roles: ['AXIE_ACCOUNT']}
      },
      {
        path: 'account_detail',
        component: () => import('@/views/axie/account_detail'),
        name: 'account_detail',
        meta: {title: '游戏帐号列表', noCache: true, roles: ['AXIE_ACCOUNT']},
        hidden: true
      },
      {
        path: 'slp',
        component: () => import('@/views/axie/slp'),
        name: 'slp',
        meta: {title: '查询药水', icon: 'si-glyph-test-tube', noCache: true, roles: ['AXIE_SLP']}
      },
      {
        path: 'slp_detail',
        component: () => import('@/views/axie/slp_detail'),
        name: 'slp_detail',
        meta: {title: '查询药水列表', noCache: true, roles: ['AXIE_SLP']},
        hidden: true
      },
      {
        path: 'status',
        component: () => import('@/views/axie/status'),
        name: 'status',
        meta: {title: '宠物状态', icon: 'si-glyph-alien', noCache: true, roles: ['AXIE_STATUS']}
      },
      {
        path: 'status_detail',
        component: () => import('@/views/axie/status_detail'),
        name: 'status_detail',
        meta: {title: '宠物状态列表', noCache: true, roles: ['AXIE_STATUS']},
        hidden: true
      },
      {
        path: 'buy',
        component: () => import('@/views/axie/buy'),
        name: 'buy',
        meta: {title: '购买宠物', icon: 'si-glyph-button-buy', noCache: true, roles: ['AXIE_BUY']}
      },
      {
        path: 'buy_detail',
        component: () => import('@/views/axie/buy_detail'),
        name: 'buy_detail',
        meta: {title: '购买宠物列表', noCache: true, roles: ['AXIE_BUY']},
        hidden: true
      },
      {
        path: 'grandma',
        component: () => import('@/views/axie/grandma'),
        name: 'grandma',
        meta: {title: '宠物分发', icon: 'si-glyph-baby-milk-botl', noCache: true, roles: ['AXIE_GRANDMA']}
      },
      {
        path: 'grandma_detail',
        component: () => import('@/views/axie/grandma_detail'),
        name: 'grandma_detail',
        meta: {title: '宠物分发列表', noCache: true, roles: ['AXIE_GRANDMA']},
        hidden: true
      },
      {
        path: 'sale',
        component: () => import('@/views/axie/sale'),
        name: 'sale',
        meta: {title: '出售宠物', icon: 'si-glyph-button-sale', noCache: true, roles: ['AXIE_SALE']}
      },
      {
        path: 'sale_detail',
        component: () => import('@/views/axie/sale_detail'),
        name: 'sale_detail',
        meta: {title: '出售宠物列表', noCache: true, roles: ['AXIE_SALE']},
        hidden: true
      },
      {
        path: 'weth',
        component: () => import('@/views/axie/weth'),
        name: 'weth',
        meta: {title: '提WETH', icon: 'si-glyph-diamond', noCache: true, roles: ['AXIE_WETH']}
      },
      {
        path: 'weth_detail',
        component: () => import('@/views/axie/weth_detail'),
        name: 'weth_detail',
        meta: {title: '提WETH列表', noCache: true, roles: ['AXIE_WETH']},
        hidden: true
      }
    ]
  },
  {
    path: '/raca',
    component: Layout,
    redirect: 'noredirect',
    name: 'raca',
    meta: {title: 'RACA', icon: 'raca'},
    children: [
      {
        path: 'buy',
        component: () => import('@/views/raca/buy'),
        name: 'buy',
        meta: {title: '购买NFT', icon: 'si-glyph-button-buy', noCache: true, roles: ['RACA_BUY']}
      },
      {
        path: 'buy_detail',
        component: () => import('@/views/raca/buy_detail'),
        name: 'buy_detail',
        meta: {title: '购买NFT列表', noCache: true, roles: ['RACA_BUY']},
        hidden: true
      }
    ]
  },
  {
    path: '/apple',
    component: Layout,
    redirect: 'noredirect',
    name: 'apple',
    meta: {title: 'APPPLE', icon: 'apple'},
    children: [
      {
        path: 'register',
        component: () => import('@/views/apple/register'),
        name: 'register',
        meta: {title: '苹果注册', icon: 'si-glyph-star-stick', noCache: true, roles: ['APPLE_REGISTER']}
      },
      {
        path: 'register_detail',
        component: () => import('@/views/apple/register_detail'),
        name: 'register_detail',
        meta: {title: '苹果注册列表', noCache: true, roles: ['APPLE_REGISTER']},
        hidden: true
      },
      {
        path: 'imessage',
        component: () => import('@/views/apple/imessage'),
        name: 'imessage',
        meta: {title: '苹果消息', icon: 'si-glyph-bubble-message', noCache: true, roles: ['APPLE_IMESSAGE']}
      },
      {
        path: 'imessage_detail',
        component: () => import('@/views/apple/imessage_detail'),
        name: 'imessage_detail',
        meta: {title: '苹果消息列表', noCache: true, roles: ['APPLE_IMESSAGE']},
        hidden: true
      }
    ]
  },
  {
    path: '/weibo',
    component: Layout,
    redirect: 'noredirect',
    name: 'weibo',
    meta: {title: '微博功能', icon: 'tree'},
    children: [
      {
        path: 'pub',
        component: () => import('@/views/weibo/pub'),
        name: 'pub',
        meta: {title: '发布微博', icon: 'si-glyph-abacus', noCache: true, roles: ['WEIBO_PUB']}
      },
      {
        path: 'pub_detail',
        component: () => import('@/views/weibo/pub_detail'),
        name: 'pub_detail',
        meta: {title: '发布微博列表', noCache: true, roles: ['WEIBO_PUB']},
        hidden: true
      }
    ]
  },
  {
    path: '/machine',
    component: Layout,
    redirect: 'noredirect',
    name: 'machine',
    meta: {title: '硬件监控', icon: 'si-glyph-sewing-machine'},
    children: [
      {
        path: 'device',
        component: () => import('@/views/machine/device'),
        name: 'device',
        meta: {title: '设备列表', icon: 'si-glyph-mobile', noCache: true, roles: ['DEVICE']}
      }
    ]
  },
  {
    path: '/otc/stats',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_stat',
    meta: {title: '群组统计', icon: 'tree'},
    children: [
      {
        path: '',
        component: () => import('@/views/otc/group/stats'),
        name: 'all',
        meta: {title: '全部', icon: 'si-glyph-abacus', noCache: true, roles: ['OTC_STAT']}
      },
      {
        path: 'income',
        component: () => import('@/views/otc/group/stats'),
        name: 'income',
        meta: {title: '入款', icon: 'si-glyph-money-bag', noCache: true, roles: ['OTC_STAT']},
        props: { action: 'INCOME' }
      },
      {
        path: 'payout',
        component: () => import('@/views/otc/group/stats'),
        name: 'payout',
        meta: {title: '下发', icon: 'si-glyph-money-$', noCache: true, roles: ['OTC_STAT']},
        props: { action: 'PAYOUT' }
      },
      {
        path: 'unnormal',
        component: () => import('@/views/otc/group/stats'),
        name: 'unnormal',
        meta: {title: '异常', icon: 'si-glyph-light-alarm', noCache: true, roles: ['OTC_STAT']},
        props: { isNormal: false }
      }
    ]
  },
  {
    path: '/otc/group',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_group',
    meta: {title: '群组管理', icon: 'peoples'},
    children: [
      {
        path: 'category',
        component: () => import('@/views/otc/group/category'),
        name: 'category',
        meta: {title: '分类管理', icon: 'nested', noCache: true, roles: ['OTC_GROUP_CATEGORY']}
      },
      {
        path: 'channel',
        component: () => import('@/views/otc/group/channel'),
        name: 'channel',
        meta: {title: '渠道管理', icon: 'si-glyph-cow', noCache: true, roles: ['OTC_GROUP_CHANNEL']}
      },
      {
        path: '',
        component: () => import('@/views/otc/group/group'),
        name: 'group',
        meta: {title: '群组功能', icon: 'example', noCache: true, roles: ['OTC_GROUP']}
      }
    ]
  },
  {
    path: '/otc/customer',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_customer',
    meta: {title: '客户管理', icon: 'people'},
    children: [
      {
        path: '',
        component: () => import('@/views/otc/customer/customer'),
        name: 'customer',
        meta: {title: '客户信息', icon: 'people', noCache: true, roles: ['OTC_CUSTOMER']}
      },
      {
        path: 'customer_card',
        component: () => import('@/views/otc/customer/customer_card'),
        name: 'customer_card',
        meta: {title: '银行卡信息', noCache: true, roles: ['OTC_CUSTOMER']},
        hidden: true
      },
      {
        path: 'card',
        component: () => import('@/views/otc/customer/card'),
        name: 'customer_card',
        meta: {title: '银行卡', icon: 'si-glyph-atm-card', noCache: true, roles: ['OTC_CUSTOMER']}
      },
      {
        path: 'record',
        component: () => import('@/views/otc/customer/record'),
        name: 'record',
        meta: {title: '下发记录', icon: 'si-glyph-signal-1', noCache: true, roles: ['OTC_CUSTOMER']}
      }
    ]
  },
  {
    path: '/otc/stat',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_stat',
    meta: {title: '统计数据', icon: 'chart'},
    children: [
      {
        path: '',
        component: () => import('@/views/otc/stat/profit'),
        name: 'profit',
        meta: {title: '利润数据', icon: 'chart', noCache: true, roles: ['OTC_CUSTOMER']}
      }
    ]
  },
  {
    path: '/otc/bill',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_bill',
    meta: {title: '交易管理', icon: 'si-glyph-money-3'},
    children: [
      {
        path: 'record',
        component: () => import('@/views/otc/bill/record'),
        name: 'record',
        meta: {title: '账单记录', icon: 'list', noCache: true, roles: ['OTC_GROUP_BILL']}
      },
      {
        path: 'pending_trade',
        component: () => import('@/views/otc/bill/pending_trade'),
        name: 'pending_trade',
        meta: {title: '订单记录', icon: 'si-glyph-calendar-3', noCache: true, roles: ['OTC_CUSTOMER']}
      },
      {
        path: 'bank_slip',
        component: () => import('@/views/otc/bill/bank_slip'),
        name: 'bank_slip',
        meta: {title: '回单记录', icon: 'si-glyph-book-4', noCache: true, roles: ['OTC_CUSTOMER']}
      }
    ]
  },
  {
    path: '/otc/telegram',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_telegram',
    meta: {title: 'Telegram', icon: 'peoples'},
    children: [
      {
        path: 'markup',
        component: () => import('@/views/otc/telegram/markup'),
        name: 'markup',
        meta: {title: '快捷按钮', icon: 'si-glyph-arrow-forward', noCache: true, roles: ['OTC_TELEGRAM']}
      }
    ]
  },
  {
    path: '/data',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_qa',
    meta: {title: '数据设置', icon: 'tree'},
    children: [
      {
        path: 'answer',
        component: () => import('@/views/data/answer'),
        name: 'answer',
        meta: {title: '自动回复', icon: 'wechat', noCache: true, roles: ['OTC_ANSWER']}
      },
      {
        path: 'kv',
        component: () => import('@/views/data/kv'),
        name: 'kv',
        meta: {title: '数据定义', icon: 'table', noCache: true, roles: ['KV_STORE']}
      }
    ]
  },
  {
    path: '/otc/risk',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_risk',
    meta: {title: '智能风控', icon: 'bug'},
    children: [
      {
        path: 'sensitive',
        component: () => import('@/views/otc/risk/sensitive'),
        name: 'sensitive',
        meta: {title: '敏感词', icon: 'language', noCache: true, roles: ['OTC_SENSITIVE']}
      },
      {
        path: 'whitelist',
        component: () => import('@/views/otc/risk/whitelist'),
        name: 'whitelist',
        meta: {title: '白名单', icon: 'user2', noCache: true, roles: ['WHITELIST']}
      }
    ]
  },
  {
    path: '/otc/auth',
    component: Layout,
    redirect: 'noredirect',
    name: 'otc_auth',
    meta: {title: '授权管理', icon: 'si-glyph-abacus'},
    children: [
      {
        path: 'bot',
        component: () => import('@/views/otc/telegram/bot'),
        name: 'otc_bot',
        meta: {title: '机器人', icon: 'si-glyph-android', noCache: true, roles: ['OTC_TELEGRAM']}
      },
      {
        path: 'admin',
        component: () => import('@/views/otc/admin'),
        name: 'otc_admin',
        meta: {title: '管理员', icon: 'people', noCache: true, roles: ['OTC_USER']}
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: 'noredirect',
    name: 'sys',
    meta: {
      title: '超级管理',
      icon: 'dashboard'
    },
    children: [
      {
        path: 'role',
        component: () => import('@/views/sys/role'),
        name: 'role',
        meta: {title: '角色管理', icon: 'role', noCache: true, roles: ['SYS']}
      },
      {
        path: 'authority',
        component: () => import('@/views/sys/authority'),
        name: 'authority',
        meta: {title: '权限管理', icon: 'si-glyph-key-2', noCache: true, roles: ['SYS']}
      },
      {
        path: 'workgorup',
        component: () => import('@/views/sys/work_gorup'),
        name: 'workgorup',
        meta: {title: '工作小组', icon: 'si-glyph-person-public', noCache: true, roles: ['SYS']}
      },
      {
        path: 'user',
        component: () => import('@/views/sys/user'),
        name: 'user',
        meta: {title: '用户管理', icon: 'peoples', noCache: true, roles: ['SYS']}
      }
      // {
      //   path: 'group',
      //   component: () => import('@/views/sys/work_gorup'),
      //   name: 'group',
      //   meta: {title: '终端授权', icon: 'si-glyph-cashier-machine', noCache: true, roles: ['SYS']}
      // }
    ]
  },
  // {
  //   path: '/alipay',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'alipayManage',
  //   meta: {
  //     title: '帐号管理',
  //     icon: 'axie-pet'
  //   },
  //   children: [
  //     {
  //       path: 'alipay',
  //       component: () => import('@/views/alipay/alipay'),
  //       name: 'alipay',
  //       meta: {title: '支付宝', noCache: true}
  //     }
  //   ]
  // },
  // {
  //   path: '/stat',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'statView',
  //   meta: {
  //     title: '金额统计',
  //     icon: 'money'
  //   },
  //   children: [
  //     {
  //       path: 'stat',
  //       component: () => import('@/views/stat/stat'),
  //       name: 'stat',
  //       meta: {title: '金额统计', noCache: true}
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/mall',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'mallManage',
  //   meta: {
  //     title: '商场管理',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'region',
  //       component: () => import('@/views/mall/region'),
  //       name: 'region',
  //       meta: {title: '行政区域', noCache: true}
  //     },
  //     {
  //       path: 'brand',
  //       component: () => import('@/views/mall/brand'),
  //       name: 'brand',
  //       meta: {title: '品牌制造商', noCache: true}
  //     },
  //     {
  //       path: 'category',
  //       component: () => import('@/views/mall/category'),
  //       name: 'category',
  //       meta: {title: '商品类目', noCache: true}
  //     },
  //     {
  //       path: 'order',
  //       component: () => import('@/views/mall/order'),
  //       name: 'order',
  //       meta: {title: '订单管理', noCache: true}
  //     },
  //     {
  //       path: 'issue',
  //       component: () => import('@/views/mall/issue'),
  //       name: 'issue',
  //       meta: {title: '通用问题', noCache: true}
  //     },
  //     {
  //       path: 'keyword',
  //       component: () => import('@/views/mall/keyword'),
  //       name: 'keyword',
  //       meta: {title: '关键词', noCache: true}
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/goods',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'goodsManage',
  //   meta: {
  //     title: '商品管理',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       component: () => import('@/views/goods/list'),
  //       name: 'goodsList',
  //       meta: {title: '商品列表', noCache: true}
  //     },
  //     {
  //       path: 'create',
  //       component: () => import('@/views/goods/create'),
  //       name: 'goodsCreate',
  //       meta: {title: '商品上架', noCache: true}
  //     },
  //     {
  //       path: 'edit',
  //       component: () => import('@/views/goods/edit'),
  //       name: 'goodsEdit',
  //       meta: {title: '商品编辑', noCache: true},
  //       hidden: true
  //     },
  //     {
  //       path: 'comment',
  //       component: () => import('@/views/goods/comment'),
  //       name: 'goodsComment',
  //       meta: {title: '商品评论', noCache: true}
  //     }
  //   ]
  // },
  // {
  //   path: '/promotion',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'promotionManage',
  //   meta: {
  //     title: '推广管理',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'ad',
  //       component: () => import('@/views/promotion/ad'),
  //       name: 'ad',
  //       meta: {title: '广告列表', noCache: true}
  //     },
  //     {
  //       path: 'topic',
  //       component: () => import('@/views/promotion/topic'),
  //       name: 'topic',
  //       meta: {title: '专题管理', noCache: true}
  //     },
  //     {
  //       path: 'groupon-rule',
  //       component: () => import('@/views/promotion/grouponRule'),
  //       name: 'grouponRule',
  //       meta: {title: '团购规则', noCache: true}
  //     },
  //     {
  //       path: 'groupon-activity',
  //       component: () => import('@/views/promotion/grouponActivity'),
  //       name: 'grouponActivity',
  //       meta: {title: '团购活动', noCache: true}
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/sys',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'sysManage',
  //   meta: {
  //     title: '系统管理',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'admin',
  //       component: () => import('@/views/sys/admin'),
  //       name: 'admin',
  //       meta: {title: '管理员', noCache: true}
  //     },
  //     {
  //       path: 'os',
  //       component: () => import('@/views/sys/os'),
  //       name: 'os',
  //       meta: {title: '对象存储', noCache: true}
  //     }
  //   ]
  // },
  //
  // {
  //   path: '/stat',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'statManage',
  //   meta: {
  //     title: '统计',
  //     icon: 'chart'
  //   },
  //   children: [
  //     {
  //       path: 'app',
  //       component: () => import('@/views/stat/app'),
  //       name: 'statUser',
  //       meta: {title: '用户统计', noCache: true}
  //     },
  //     {
  //       path: 'order',
  //       component: () => import('@/views/stat/order'),
  //       name: 'statOrder',
  //       meta: {title: '订单统计', noCache: true}
  //     },
  //     {
  //       path: 'goods',
  //       component: () => import('@/views/stat/goods'),
  //       name: 'statGoods',
  //       meta: {title: '商品统计', noCache: true}
  //     }
  //   ]
  // },
  // {
  //   path: 'external-link',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'externalLink',
  //   meta: {
  //     title: '外链',
  //     icon: 'link'
  //   },
  //   children: [
  //     {
  //       path: 'https://cloud.tencent.com/product/cos',
  //       meta: {title: '腾讯云存储', icon: 'link'}
  //     },
  //     {
  //       path: 'https://cloud.tencent.com/product/sms',
  //       meta: {title: '腾讯云短信', icon: 'link'}
  //     },
  //     {
  //       path: 'https://pay.weixin.qq.com/index.php/core/home/login',
  //       meta: {title: '微信支付', icon: 'link'}
  //     },
  //     {
  //       path: 'https://mpkf.weixin.qq.com/',
  //       meta: {title: '小程序客服', icon: 'link'}
  //     },
  //     {
  //       path: 'https://www.alibabacloud.com/zh/product/oss',
  //       meta: {title: '阿里云存储', icon: 'link'}
  //     },
  //     {
  //       path: 'https://www.qiniu.com/products/kodo',
  //       meta: {title: '七牛云存储', icon: 'link'}
  //     },
  //     {
  //       path: 'http://www.kdniao.com/api-track',
  //       meta: {title: '快递鸟', icon: 'link'}
  //     }
  //   ]
  // },
  {
    path: '/setting',
    component: Layout,
    redirect: 'noredirect',
    name: 'setting',
    meta: {
      title: '设置',
      icon: 'setting'
    },
    children: [
      {
        path: 'app_setting',
        component: () => import('@/views/setting/app_setting'),
        name: 'app_setting',
        meta: {title: '应用', icon: 'si-glyph-wrench-screwdriver', noCache: true, authorities: ['AppSettingGiftPetLimiter']}
      },
      {
        path: 'password',
        component: () => import('@/views/profile/password'),
        name: 'password',
        meta: {title: '密码', icon: 'password', noCache: true}
      }
    ]
    // hidden: true
  },
  {path: '*', redirect: '/404', hidden: true}
]



// WEBPACK FOOTER //
// ./src/router/index.js